(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sleep-card-soft-edges"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function isMobile() {
      return window.innerWidth <= 768;
    }

    function initCarousels() {
      const grids = document.querySelectorAll('[id^="sleep-carousel-"]');
      
      grids.forEach(grid => {
        const gridId = grid.id;
        const sectionId = gridId.replace('sleep-carousel-', '');
        const cards = grid.querySelectorAll('.feature-card');
        const prevBtn = document.querySelector(`.prev[data-carousel="${gridId}"]`);
        const nextBtn = document.querySelector(`.next[data-carousel="${gridId}"]`);
        const wrapper = grid.closest('.feature-list-grid-wrapper');
        
        if (!prevBtn || !nextBtn) return;
        
        // Verifica se o drag está habilitado (vem do atributo data)
        const dragEnabledAttr = wrapper ? wrapper.getAttribute('data-enable-drag') : null;
        const dragEnabled = dragEnabledAttr !== null ? dragEnabledAttr === 'true' : true; // default true se não especificado
        
        let index = 0;
        
        // Variáveis para drag/swipe
        let touchStartX = 0;
        let touchStartY = 0;
        let touchEndX = 0;
        let isDragging = false;
        let dragStartX = 0;
        let dragStartY = 0;
        const minSwipeDistance = 50;
        const axisThreshold = 10;

        function updateCarousel() {
          if (!isMobile()) {
            // Remove active class in desktop
            cards.forEach(card => card.classList.remove('active'));
            return;
          }
          
          cards.forEach((card, i) => {
            card.classList.remove('active');
          });
          if (cards[index]) {
            cards[index].classList.add('active');
          }
        }

        function goToNext() {
          if (!isMobile()) return;
          index = (index + 1) % cards.length;
          updateCarousel();
        }

        function goToPrev() {
          if (!isMobile()) return;
          index = (index - 1 + cards.length) % cards.length;
          updateCarousel();
        }

        // Set initial active card only on mobile
        if (isMobile() && cards.length > 0) {
          cards[0].classList.add('active');
        }

        // Event listeners para botões
        nextBtn.addEventListener('click', () => {
          if (!isMobile()) return;
          goToNext();
        });

        prevBtn.addEventListener('click', () => {
          if (!isMobile()) return;
          goToPrev();
        });

        // Funcionalidade de drag/swipe (apenas se habilitado)
        if (dragEnabled && wrapper) {
          // Touch events para mobile
          function handleTouchStart(e) {
            if (!isMobile()) return;
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
            isDragging = true;
          }

          function handleTouchMove(e) {
            if (!isMobile() || !isDragging) return;
            const touch = e.changedTouches[0];
            const deltaX = Math.abs(touch.screenX - touchStartX);
            const deltaY = Math.abs(touch.screenY - touchStartY);
            if (deltaX > deltaY && deltaX > axisThreshold) {
              e.preventDefault();
            }
          }

          function handleTouchEnd(e) {
            if (!isMobile() || !isDragging) return;
            touchEndX = e.changedTouches[0].screenX;
            const swipeDistance = touchStartX - touchEndX;
            
            if (Math.abs(swipeDistance) >= minSwipeDistance) {
              if (swipeDistance > 0) {
                goToNext();
              } else {
                goToPrev();
              }
            }
            isDragging = false;
          }

          // Mouse/Pointer events para desktop e mobile
          function handlePointerDown(e) {
            if (!isMobile()) return;
            if (e.button !== 0 && e.pointerType === 'mouse') return; // Apenas botão esquerdo do mouse
            isDragging = true;
            dragStartX = e.screenX || e.clientX;
            dragStartY = e.screenY || e.clientY;
            wrapper.style.cursor = 'grabbing';
            wrapper.style.userSelect = 'none';
          }

          function handlePointerMove(e) {
            if (!isMobile() || !isDragging) return;
            // Previne scroll durante o drag
            if (Math.abs((e.screenX || e.clientX) - dragStartX) > 10) {
              e.preventDefault();
            }
          }

          function handlePointerUp(e) {
            if (!isMobile() || !isDragging) return;
            const dragEndX = e.screenX || e.clientX;
            const dragEndY = e.screenY || e.clientY;
            const deltaX = dragStartX - dragEndX;
            const deltaY = Math.abs(dragStartY - dragEndY);
            
            // Só considera swipe se movimento horizontal for maior que vertical
            if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) >= minSwipeDistance) {
              if (deltaX > 0) {
                goToNext();
              } else {
                goToPrev();
              }
            }
            
            isDragging = false;
            wrapper.style.cursor = '';
            wrapper.style.userSelect = '';
          }

          // Adiciona event listeners
          wrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
          wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
          wrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
          wrapper.addEventListener('pointerdown', handlePointerDown);
          wrapper.addEventListener('pointermove', handlePointerMove);
          wrapper.addEventListener('pointerup', handlePointerUp);
          wrapper.addEventListener('pointercancel', handlePointerUp);

          // Previne drag nativo de imagens
          const images = wrapper.querySelectorAll('img');
          images.forEach(img => {
            img.addEventListener('dragstart', function(e) { 
              e.preventDefault(); 
            });
          });
        }

        // Handle resize
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            updateCarousel();
          }, 250);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      initCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-footer"] && !Shopify.designMode) return;
  try {
    
  // Mobile accordion
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.sleep-footer__column-title').forEach(title => {
      title.addEventListener('click', () => title.parentElement.classList.toggle('active'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-our-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function isMobile() {
      return window.innerWidth <= 768;
    }

    function initProductCarousels() {
      const grids = document.querySelectorAll('[id^="product-carousel-"]');
      
      grids.forEach(grid => {
        const gridId = grid.id;
        let wrappers = Array.from(grid.querySelectorAll('.product-image-wrapper'));
        const prevBtn = document.querySelector(`.prev[data-carousel="${gridId}"]`);
        const nextBtn = document.querySelector(`.next[data-carousel="${gridId}"]`);
        
        if (!prevBtn || !nextBtn || wrappers.length === 0) return;
        
        let currentIndex = 0;
        let fakeElementStart = null;
        let fakeElementEnd = null;
        let realImagesCount = 0;
        let touchStartX = 0;
        let touchEndX = 0;
        let minSwipeDistance = 50;

        function createFakeElements() {
          if (fakeElementStart && fakeElementEnd) return;
          
          // Count real images before adding fake elements
          realImagesCount = wrappers.length;
          
          // Create fake element for start
          if (!fakeElementStart) {
            fakeElementStart = document.createElement('div');
            fakeElementStart.className = 'product-image-wrapper fake-wrapper fake-start';
            fakeElementStart.style.cssText = 'width: 15vw; height: 400px; display: none; background: transparent;';
            grid.insertBefore(fakeElementStart, grid.firstChild);
          }

          // Create fake element for end
          if (!fakeElementEnd) {
            fakeElementEnd = document.createElement('div');
            fakeElementEnd.className = 'product-image-wrapper fake-wrapper fake-end';
            fakeElementEnd.style.cssText = 'width: 15vw; height: 400px; margin-right: 5vw; display: none; background: transparent;';
            grid.appendChild(fakeElementEnd);
          }
          
          // Update wrappers array to include fake elements
          wrappers = Array.from(grid.querySelectorAll('.product-image-wrapper'));
        }

        function removeFakeElements() {
          if (fakeElementStart && fakeElementStart.parentNode) {
            fakeElementStart.parentNode.removeChild(fakeElementStart);
            fakeElementStart = null;
          }
          if (fakeElementEnd && fakeElementEnd.parentNode) {
            fakeElementEnd.parentNode.removeChild(fakeElementEnd);
            fakeElementEnd = null;
          }
          wrappers = Array.from(grid.querySelectorAll('.product-image-wrapper'));
          realImagesCount = wrappers.length;
        }

        function updateButtonStates() {
          if (!isMobile()) {
            prevBtn.disabled = false;
            nextBtn.disabled = false;
            return;
          }

          // Get the real index (subtract 1 for fake start element)
          const realIndex = currentIndex - 1;
          
          // Disable prev button if on first real image
          prevBtn.disabled = (realIndex <= 0);
          
          // Disable next button if on last real image
          nextBtn.disabled = (realIndex >= realImagesCount - 1);
        }

        function goToNext() {
          if (!isMobile()) return;
          
          const realIndex = currentIndex - 1;
          if (realIndex < realImagesCount - 1) {
            currentIndex++;
            updateCarousel();
          }
        }

        function goToPrev() {
          if (!isMobile()) return;
          
          const realIndex = currentIndex - 1;
          if (realIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        }

        function handleTouchStart(e) {
          if (!isMobile()) return;
          touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
          if (!isMobile()) return;
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        }

        function handleSwipe() {
          const swipeDistance = touchStartX - touchEndX;
          
          if (Math.abs(swipeDistance) < minSwipeDistance) {
            return; // Not enough swipe distance
          }
          
          if (swipeDistance > 0) {
            // Swipe left - go to next image
            goToNext();
          } else {
            // Swipe right - go to previous image
            goToPrev();
          }
        }

        function updateCarousel() {
          if (!isMobile()) {
            // Reset on desktop - remove fake elements
            removeFakeElements();
            wrappers.forEach((wrapper, i) => {
              wrapper.classList.remove('active');
              wrapper.style.display = '';
              wrapper.style.width = '';
              wrapper.style.margin = '';
              wrapper.style.marginLeft = '';
              wrapper.style.marginRight = '';
            });
            updateButtonStates();
            return;
          }

          // Create fake elements for mobile if they don't exist
          createFakeElements();

          // Hide all images first and reset styles
          wrappers.forEach(wrapper => {
            wrapper.style.display = 'none';
            wrapper.classList.remove('active');
            wrapper.style.width = '';
            wrapper.style.margin = '0';
            wrapper.style.marginLeft = '';
            wrapper.style.marginRight = '';
          });

          // Calculate which images to show
          const totalImages = wrappers.length;
          const prevIndex = currentIndex - 1;
          const nextIndex = currentIndex + 1;

          // Show previous image on the left (15%) - could be fake element
          if (prevIndex >= 0 && wrappers[prevIndex]) {
            wrappers[prevIndex].style.display = 'block';
            wrappers[prevIndex].style.width = '15vw';
            wrappers[prevIndex].style.marginLeft = '5vw';
          }

          // Show current image in center (60%) - ALWAYS ACTIVE
          if (wrappers[currentIndex]) {
            wrappers[currentIndex].style.display = 'block';
            wrappers[currentIndex].style.width = '60vw';
            if (!wrappers[currentIndex].classList.contains('fake-wrapper')) {
              wrappers[currentIndex].classList.add('active');
            }
          }

          // Show next image on the right (15%) - could be fake element
          if (nextIndex < totalImages && wrappers[nextIndex]) {
            wrappers[nextIndex].style.display = 'block';
            wrappers[nextIndex].style.width = '15vw';
            wrappers[nextIndex].style.marginRight = '5vw';
          }

          // Update button states
          updateButtonStates();
        }

        // Initialize carousel on mobile - start at index 1 (first real image)
        if (isMobile() && wrappers.length > 0) {
          currentIndex = 1; // Start at first real image (fake-start will be at index 0)
          updateCarousel();
        }

        // Button event listeners
        nextBtn.addEventListener('click', () => {
          if (!nextBtn.disabled) {
            goToNext();
          }
        });

        prevBtn.addEventListener('click', () => {
          if (!prevBtn.disabled) {
            goToPrev();
          }
        });

        // Touch event listeners for swipe navigation
        grid.addEventListener('touchstart', handleTouchStart, { passive: true });
        grid.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Handle resize
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            if (isMobile()) {
              // Ensure we don't start on fake element after resize
              if (currentIndex < 1) {
                currentIndex = 1; // Go to first real image
              } else if (currentIndex > realImagesCount) {
                currentIndex = realImagesCount; // Go to last real image
              }
            }
            updateCarousel();
          }, 250);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductCarousels);
    } else {
      initProductCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-shoppable-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const isMobile = window.innerWidth <= 768;
    const hotspots = document.querySelectorAll('.sleep-shoppable-banner__hotspot');
    
    hotspots.forEach(hotspot => {
      const point = hotspot.querySelector('.sleep-shoppable-banner__point');
      const popup = hotspot.querySelector('.sleep-shoppable-banner__popup');
      
      let showTimeout;
      let hideTimeout;
      
      const showPopup = () => {
        clearTimeout(hideTimeout);
        showTimeout = setTimeout(() => {
          popup.classList.add('sleep-shoppable-banner__popup--visible');
          positionPopup(hotspot, popup);
        }, 100);
      };
      
      const hidePopup = () => {
        clearTimeout(showTimeout);
        hideTimeout = setTimeout(() => {
          popup.classList.remove('sleep-shoppable-banner__popup--visible');
        }, 200);
      };
      
      const positionPopup = (hotspot, popup) => {
        const hotspotRect = hotspot.getBoundingClientRect();
        const popupRect = popup.getBoundingClientRect();
        const container = hotspot.closest('.sleep-shoppable-banner__image-wrapper');
        const containerRect = container.getBoundingClientRect();
        
        // Remove previous position classes
        popup.classList.remove('sleep-shoppable-banner__popup--left', 'sleep-shoppable-banner__popup--right');
        
        // Check if popup fits on the right
        if (hotspotRect.left + popupRect.width + 20 < containerRect.right) {
          popup.classList.add('sleep-shoppable-banner__popup--right');
        } else {
          popup.classList.add('sleep-shoppable-banner__popup--left');
        }
      };
      
      hotspot.addEventListener('mouseenter', showPopup);
      hotspot.addEventListener('mouseleave', hidePopup);
      
      popup.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
      });
      
      popup.addEventListener('mouseleave', hidePopup);
    });
    
    // Variant image change functionality for popups
    const popupVariants = document.querySelectorAll('.sleep-shoppable-banner__popup-variant-swatch');
    popupVariants.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const popup = this.closest('.sleep-shoppable-banner__popup');
        const variantImage = this.getAttribute('data-variant-image');
        const variantUrl = this.getAttribute('data-variant-url');
        
        // Update image
        if (variantImage) {
          const productImage = popup.querySelector('.sleep-shoppable-banner__popup-image img');
          if (productImage) {
            productImage.src = variantImage;
          }
        }
        
        // Update button link
        if (variantUrl) {
          const productLink = popup.querySelector('.sleep-shoppable-banner__popup-button');
          if (productLink) {
            productLink.href = variantUrl;
          }
        }
        
        // Remove active class from all swatches in this popup
        const allSwatches = popup.querySelectorAll('.sleep-shoppable-banner__popup-variant-swatch');
        allSwatches.forEach(s => s.classList.remove('sleep-shoppable-banner__popup-variant-swatch--active'));
        
        // Add active class to clicked swatch
        this.classList.add('sleep-shoppable-banner__popup-variant-swatch--active');
      });
    });
    
    // Mobile carousel functionality
    const mobileToggle = document.querySelector('.sleep-shoppable-banner__mobile-toggle');
    const mobileCarousel = document.querySelector('.sleep-shoppable-banner__mobile-carousel');
    
    if (mobileToggle && mobileCarousel) {
      mobileToggle.addEventListener('click', function() {
        mobileCarousel.classList.toggle('sleep-shoppable-banner__mobile-carousel--visible');
        mobileToggle.classList.toggle('sleep-shoppable-banner__mobile-toggle--active');
      });
      
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-tech-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.tech-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.tech-slide');
    const nextBtn = carousel.querySelector('.tech-next');
    const prevBtn = carousel.querySelector('.tech-prev');
    const track = carousel.querySelector('.tech-carousel-track');

    if (slides.length === 0) return;

    // Verifica se o drag está habilitado (vem do atributo data)
    const dragEnabledAttr = carousel.getAttribute('data-enable-drag');
    const dragEnabled = dragEnabledAttr !== null ? dragEnabledAttr === 'true' : true; // default true se não especificado

    let index = 0;

    // Set initial active slide
    slides[0].classList.add('active');

    function updateCarousel() {
      slides.forEach((slide, i) => {
        slide.classList.remove('active');
      });
      if (slides[index]) {
        slides[index].classList.add('active');
      }
    }

    function goToNext() {
      index = (index + 1) % slides.length;
      updateCarousel();
    }

    function goToPrev() {
      index = (index - 1 + slides.length) % slides.length;
      updateCarousel();
    }

    // Event listeners para botões
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goToNext();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goToPrev();
      });
    }

    // Funcionalidade de drag/swipe (apenas se habilitado)
    if (dragEnabled && track) {
      // Variáveis para drag/swipe
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartY = 0;
      const minSwipeDistance = 50;
      const axisThreshold = 10; // mínimo de movimento para decidir direção

      // Touch events para mobile
      function handleTouchStart(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isDragging = true;
      }

      function handleTouchMove(e) {
        if (!isDragging) return;
        const touch = e.changedTouches[0];
        const deltaX = Math.abs(touch.screenX - touchStartX);
        const deltaY = Math.abs(touch.screenY - touchStartY);
        // Só previne scroll da página quando o gesto for claramente horizontal (swipe do carrossel)
        if (deltaX > deltaY && deltaX > axisThreshold) {
          e.preventDefault();
        }
      }

      function handleTouchEnd(e) {
        if (!isDragging) return;
        touchEndX = e.changedTouches[0].screenX;
        const swipeDistance = touchStartX - touchEndX;
        
        if (Math.abs(swipeDistance) >= minSwipeDistance) {
          if (swipeDistance > 0) {
            goToNext();
          } else {
            goToPrev();
          }
        }
        isDragging = false;
      }

      // Mouse/Pointer events para desktop e mobile
      function handlePointerDown(e) {
        if (e.button !== 0 && e.pointerType === 'mouse') return; // Apenas botão esquerdo do mouse
        isDragging = true;
        dragStartX = e.screenX || e.clientX;
        dragStartY = e.screenY || e.clientY;
        track.style.cursor = 'grabbing';
        track.style.userSelect = 'none';
      }

      function handlePointerMove(e) {
        if (!isDragging) return;
        // Previne scroll durante o drag
        if (Math.abs((e.screenX || e.clientX) - dragStartX) > 10) {
          e.preventDefault();
        }
      }

      function handlePointerUp(e) {
        if (!isDragging) return;
        const dragEndX = e.screenX || e.clientX;
        const dragEndY = e.screenY || e.clientY;
        const deltaX = dragStartX - dragEndX;
        const deltaY = Math.abs(dragStartY - dragEndY);
        
        // Só considera swipe se movimento horizontal for maior que vertical
        if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) >= minSwipeDistance) {
          if (deltaX > 0) {
            goToNext();
          } else {
            goToPrev();
          }
        }
        
        isDragging = false;
        track.style.cursor = '';
        track.style.userSelect = '';
      }

      // Adiciona event listeners
      track.addEventListener('touchstart', handleTouchStart, { passive: true });
      track.addEventListener('touchmove', handleTouchMove, { passive: false });
      track.addEventListener('touchend', handleTouchEnd, { passive: true });
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', handlePointerUp);
      track.addEventListener('pointercancel', handlePointerUp);

      // Previne drag nativo de imagens e vídeos
      const images = track.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', function(e) { 
          e.preventDefault(); 
        });
      });

      const videos = track.querySelectorAll('video');
      videos.forEach(video => {
        video.addEventListener('dragstart', function(e) { 
          e.preventDefault(); 
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
